import React from "react";
import Weather from './Weather'
import Clothes from './Clothes'
import Example from './Example'

const App = () => {
    return (
        <>
        <h1> logo </h1>
        <Weather />
        <Clothes />
        <Example />
        </>
    );
};

export default App;